/*!

=========================================================
* Argon Dashboard React - v1.2.4
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import { Link } from "react-router-dom";
import { getAuthUser } from "components/Auth/authStore";
import {
  UncontrolledCollapse,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col,
} from "reactstrap";

const APP_BASE_RAW = process.env.PUBLIC_URL || "";
const APP_BASE =
  APP_BASE_RAW && APP_BASE_RAW !== "/" ? APP_BASE_RAW.replace(/\/+$/, "") : "";

const EFSANELER_HOME_URL = "https://efsaneler.karadenizdestinasyonu.com.tr/";
const EFSANELER_LOGO_SRC = `${process.env.PUBLIC_URL}/efsaneler-logo.png`;

const AuthNavbar = () => {
  const brandHref = "https://www.karadenizdestinasyonu.com.tr/";
  const localUser = getAuthUser();
  const profileTo = localUser ? `${APP_BASE}/admin/user-profile` : `${APP_BASE}/auth/login`;

  return (
    <>
      <Navbar className="navbar-top navbar-horizontal navbar-dark" expand="md">
        <Container className="px-4">
          <div className="d-flex align-items-center">
            <NavbarBrand href={brandHref} className="mb-0">
              <img
                alt="..."
                src={require("../../assets/img/brand/white.png")}
              />
            </NavbarBrand>

            <a
              href={EFSANELER_HOME_URL}
              aria-label="Karadeniz Efsaneleri"
              className="ml-2 d-inline-flex align-items-center"
            >
              <img
                src={EFSANELER_LOGO_SRC}
                alt="Karadeniz Efsaneleri"
                loading="lazy"
                style={{ height: 36, width: "auto", objectFit: "contain" }}
                onError={(e) => {
                  e.currentTarget.style.display = "none";
                }}
              />
            </a>
          </div>
          <button className="navbar-toggler" id="navbar-collapse-main">
            <span className="navbar-toggler-icon" />
          </button>
          <UncontrolledCollapse navbar toggler="#navbar-collapse-main">
            <div className="navbar-collapse-header d-md-none">
              <Row>
                <Col className="collapse-brand" xs="6">
                  <div className="d-flex align-items-center">
                    <a href={brandHref}>
                      <img
                        alt="..."
                        src={require("../../assets/img/brand/blue.png")}
                      />
                    </a>
                    <a
                      href={EFSANELER_HOME_URL}
                      aria-label="Karadeniz Efsaneleri"
                      className="ml-2 d-inline-flex align-items-center"
                    >
                      <img
                        src={EFSANELER_LOGO_SRC}
                        alt="Karadeniz Efsaneleri"
                        loading="lazy"
                        style={{ height: 32, width: "auto", objectFit: "contain" }}
                        onError={(e) => {
                          e.currentTarget.style.display = "none";
                        }}
                      />
                    </a>
                  </div>
                </Col>
                <Col className="collapse-close" xs="6">
                  <button className="navbar-toggler" id="navbar-collapse-main">
                    <span />
                    <span />
                  </button>
                </Col>
              </Row>
            </div>
            <Nav className="ml-auto" navbar>
              <NavItem>
                <NavLink className="nav-link-icon" to={`${APP_BASE}/admin/index`} tag={Link}>
                  <i className="ni ni-tv-2" />
                  <span className="nav-link-inner--text">Anasayfa</span>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className="nav-link-icon"
                  to={`${APP_BASE}/admin/content/legends/new`}
                  tag={Link}
                >
                  <i className="ni ni-fat-add" />
                  <span className="nav-link-inner--text">Yeni Efsane Ekle</span>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink className="nav-link-icon" to={`${APP_BASE}/auth/login`} tag={Link}>
                  <i className="ni ni-key-25" />
                  <span className="nav-link-inner--text">Giriş Yap/Üye Ol</span>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink className="nav-link-icon" to={profileTo} tag={Link}>
                  <i className="ni ni-single-02" />
                  <span className="nav-link-inner--text">Profil</span>
                </NavLink>
              </NavItem>
            </Nav>
          </UncontrolledCollapse>
        </Container>
      </Navbar>
    </>
  );
};

export default AuthNavbar;
